/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CostflowDto } from '../../models/costflow-dto';

export interface GetEffectiveCostflow$Params {
  projectId: string;
  budgetIds?: Array<string>;
  isLabor?: boolean | null;
  costTypesIds?: Array<string>;
  workPackageIds?: Array<string>;
  from?: string | null;
  to?: string | null;
}

export function getEffectiveCostflow(http: HttpClient, rootUrl: string, params: GetEffectiveCostflow$Params, context?: HttpContext): Observable<StrictHttpResponse<CostflowDto>> {
  const rb = new RequestBuilder(rootUrl, getEffectiveCostflow.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('budgetIds', params.budgetIds, {});
    rb.query('isLabor', params.isLabor, {});
    rb.query('costTypesIds', params.costTypesIds, {});
    rb.query('workPackageIds', params.workPackageIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CostflowDto>;
    })
  );
}

getEffectiveCostflow.PATH = '/v0/Costflow/effective';
